import { ArrowUpRight, Instagram, Mail } from "lucide-react";
import { CONTACT_EMAIL, INSTAGRAM_HANDLE, INSTAGRAM_URL } from "../content";
import { Reveal } from "./Reveal";

const Contact = () => (
  <section id="contact" className="contact section-pad" data-testid="contact-section">
    <Reveal className="contact-inner">
      <p className="eyebrow eyebrow-light" data-testid="contact-eyebrow">Say hello</p>
      <h2 className="contact-title">
        Let's work <em>together</em>
      </h2>
      <p className="contact-copy">Questions about coaching, sessions or events? Reach out and we'll get back to you.</p>
      <div className="contact-actions">
        <a className="btn btn-on-dark btn-primary-light" href={`mailto:${CONTACT_EMAIL}`} data-testid="contact-email-button">
          <Mail size={16} /> Email Us
        </a>
        <a className="contact-instagram" href={INSTAGRAM_URL} target="_blank" rel="noreferrer" data-testid="contact-instagram-link">
          <Instagram size={16} /> Instagram: {INSTAGRAM_HANDLE} <ArrowUpRight size={14} />
        </a>
      </div>
    </Reveal>
  </section>
);

export default Contact;
